import React from 'react'

import { Popover, Skeleton } from '@mui/material'
import { CheckCircleOutlined, ErrorOutline } from '@mui/icons-material'

import { Body1, Body2, Caption, DateInfo, Grid, Stack } from '@collaborate-health/uikit'
import { CertificateStatusType } from '@tabeeb/contracts/main-api/swagger-main-api'
import { UserQualificationStatusChip } from '@tabeeb/modules/qualifications/components'
import { CertificateScopeTypeDisplayName } from '@tabeeb/modules/certificates/enums'

import { useUser } from '../../../../../users/hooks'

import {
  CertificateListItem,
  QualificationDetailsContainer,
  StyledCertificatesList,
} from './CheckInQualificationPopover.styles'
import { CheckInQualificationPopoverProps } from './CheckInQualificationPopover.types'

const CheckInQualificationPopover: React.FC<CheckInQualificationPopoverProps> = ({
  open,
  anchorEl,
  onClose,
  qualificationVersion,
  user,
}) => {
  const { loading: isAssignerLoading, user: assigner } = useUser({
    identityGuid: qualificationVersion.QualificationVersionAssignedBy,
    enabled: open,
  })

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Grid container spacing={2} p={2} width='800px' height='450px'>
        <Grid item xs={6} height='100%'>
          <StyledCertificatesList>
            {!qualificationVersion.Certificates ||
              (qualificationVersion.Certificates.length === 0 && (
                <Stack justifyContent='center' height='100%'>
                  <Body1 textAlign='center'>No certificates to show</Body1>
                </Stack>
              ))}
            {qualificationVersion.Certificates &&
              qualificationVersion.Certificates.length > 0 &&
              qualificationVersion.Certificates.map((certificate) => (
                <CertificateListItem
                  key={certificate.Id}
                  approved={certificate.Status === CertificateStatusType.Approved}
                >
                  <Stack width='100%'>
                    <Stack direction='row' justifyContent='space-between'>
                      <Body1>{certificate.TypeName}</Body1>
                      {certificate.Status === CertificateStatusType.Approved ? (
                        <CheckCircleOutlined color='success' />
                      ) : (
                        <ErrorOutline color='error' />
                      )}
                    </Stack>
                    <Body2>Category: {certificate.CertificateCategory}</Body2>
                    <Body2>Scope: {CertificateScopeTypeDisplayName[certificate.CertificateScope]}</Body2>
                  </Stack>
                </CertificateListItem>
              ))}
          </StyledCertificatesList>
        </Grid>

        <Grid item xs={6} height='100%'>
          <QualificationDetailsContainer>
            <Stack spacing={3}>
              <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <Body2>Qualification version</Body2>
                <Body1>{qualificationVersion.Name}</Body1>
              </Stack>

              <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <Body2>Status</Body2>
                <UserQualificationStatusChip status={qualificationVersion.Status} variant='outlined' />
              </Stack>

              <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <Body2>Created on</Body2>
                <DateInfo date={qualificationVersion.QualificationVersionCreatedOn} />
              </Stack>

              <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <Body2>Version expires</Body2>
                <DateInfo date={qualificationVersion.QualificationVersionCreatedOn} />
              </Stack>

              <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <Body2>Assigned by</Body2>
                {isAssignerLoading && (
                  <Stack>
                    <Skeleton width='40px' variant='rounded' />
                    <Skeleton width='40px' variant='rounded' />
                  </Stack>
                )}
                {assigner && (
                  <Stack alignItems='flex-end'>
                    <Body1>{assigner.Name}</Body1>
                    <Caption>{assigner.Email}</Caption>
                  </Stack>
                )}
              </Stack>

              <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <Body2>Assigned to</Body2>
                <Stack alignItems='flex-end'>
                  <Body1>{user.UserName}</Body1>
                  <Caption>{user.UserEmail}</Caption>
                </Stack>
              </Stack>
            </Stack>
          </QualificationDetailsContainer>
        </Grid>
      </Grid>
    </Popover>
  )
}

export default CheckInQualificationPopover

